import { motion, AnimatePresence } from 'framer-motion';
import type { TableSlot } from '@durakapp/engine';
import { CardFace } from './Card.js';

interface Props {
  slots: TableSlot[];
}

export function Table({ slots }: Props) {
  return (
    <div className="relative flex h-44 w-full items-center justify-center">
      <div className="flex flex-wrap items-center justify-center gap-2 px-4">
        <AnimatePresence>
          {slots.map((slot, idx) => (
            <motion.div
              key={`${slot.attack.suit}-${slot.attack.rank}-${idx}`}
              initial={{ y: -40, opacity: 0, rotate: -8 }}
              animate={{ y: 0, opacity: 1, rotate: 0 }}
              exit={{ y: 60, opacity: 0 }}
              transition={{ duration: 0.26, ease: [0.33, 1, 0.68, 1] }}
              className="relative"
            >
              <CardFace card={slot.attack} size="md" />
              {slot.defense && (
                <motion.div
                  className="absolute left-3 top-3 origin-bottom-left"
                  initial={{ y: -20, opacity: 0, rotate: -22 }}
                  animate={{ y: 0, opacity: 1, rotate: 22 }}
                  transition={{
                    duration: 0.28,
                    ease: [0.34, 1.56, 0.64, 1],
                  }}
                >
                  <CardFace card={slot.defense} size="md" />
                </motion.div>
              )}
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
